// Core: Turbo setup, alerts, modals, drawers and dropdowns. Every app needs it.
import './turbo'
import '@shoelace-style/shoelace/dist/components/icon/icon.js'
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js'
import '@shoelace-style/shoelace/dist/components/drawer/drawer.js'
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js'
import '@shoelace-style/shoelace/dist/components/divider/divider.js'
import '@shoelace-style/shoelace/dist/components/menu/menu.js'
import '@shoelace-style/shoelace/dist/components/menu-item/menu-item.js'
import '@shoelace-style/shoelace/dist/components/tab/tab.js'
import '@shoelace-style/shoelace/dist/components/tab-group/tab-group.js'
import '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js'
import Dropdown from 'stimulus-dropdown'
import { ClipboardController, ScrollToTopController } from 'stimulus-library'
import AlertController from '../../view_components/core/alert_component/alert_component'
import TurboModalController from '../../view_components/core/turbo_modal/turbo_modal'
import TurboDrawerController from '../../view_components/core/turbo_drawer/turbo_drawer'
import AnchorController from './controllers/anchor_controller'
import ClickController from './controllers/click_controller'
import CopyButtonController from './controllers/copy_button_controller'
import ToggleClassController from './controllers/toggle_class_controller'

export function register(application) {
  application.register('dropdown', Dropdown)
  application.register('clipboard', ClipboardController)
  application.register('scroll-to-top', ScrollToTopController)
  application.register('alert', AlertController)
  application.register('turbo-modal', TurboModalController)
  application.register('turbo-drawer', TurboDrawerController)
  application.register('anchor', AnchorController)
  application.register('click', ClickController)
  application.register('copy-button', CopyButtonController)
  application.register('class-toggle', ToggleClassController)
}
